import { createSelector } from "reselect";

import { IntegrationTypes } from "constants/integrations";

import { selectBusinessRelationsByBusinessIdLookup } from "../businessRelations";
import { getActiveLivestockAgentDeployment } from "../deploymentActiveAgent";
import { selectIntegrationBusinessesByBusinessIdByTypeLookup } from "../integrationBusinesses";
import {
  selectInterestSettingsByDeploymentIdLookup,
  selectResolvedInterestSettingsByBusinessIdLookup,
} from "../interest";
import { getBusinesses } from "../root";
import { selectBusinessTradingTermsByIdLookup } from "../tradingTerms";
import { selectVendorCommissionBandsByDeploymentBusinessIdLookup } from "../vendorCommissionBands";

export const selectBusinessesAggridDataById = createSelector(
  [
    getBusinesses,
    selectResolvedInterestSettingsByBusinessIdLookup,
    selectVendorCommissionBandsByDeploymentBusinessIdLookup,
    getActiveLivestockAgentDeployment,
    selectBusinessRelationsByBusinessIdLookup,
    selectBusinessTradingTermsByIdLookup,
    selectInterestSettingsByDeploymentIdLookup,
    selectIntegrationBusinessesByBusinessIdByTypeLookup,
  ],
  (
    businessByIdLookup,
    resolvedInterestSettingsByBusinessId,
    vendorCommissionsByDeploymentBusinessId,
    activeLivestockAgentDeployment,
    businessRelationsByBusinessIdLookup,
    tradingTermsByBusinessIdLookup,
    interestSettingsByDeploymentIdLookup,
    integrationBusinessesByTypeByBusinessIdLookup,
  ) => {
    return Object.values(businessByIdLookup).reduce((acc, business) => {
      const vendorCommissionBands =
        vendorCommissionsByDeploymentBusinessId[
          business?.deploymentBusinessId
        ] || [];

      const xeroIntegrationBusiness =
        integrationBusinessesByTypeByBusinessIdLookup[IntegrationTypes.Xero]?.[
          business.id
        ]?.[0] || null;

      const tradingTerms = tradingTermsByBusinessIdLookup[business.id] || [];
      const businessInterestSettings =
        resolvedInterestSettingsByBusinessId[business.id];
      const deploymentInterestSettings =
        interestSettingsByDeploymentIdLookup[
          activeLivestockAgentDeployment?.id
        ];
      const relationships = businessRelationsByBusinessIdLookup[business.id];
      acc[business.id] = {
        business: {
          ...business,
          // Filter hidden things.
          properties: business.properties.filter(
            businessProperty => businessProperty.isShown,
          ),
          buyerWays: business.buyerWays.filter(buyerWay => buyerWay.isShown),
        },
        deployment: activeLivestockAgentDeployment,
        tradingTerms,
        // If we aren't overriding the interest settings, use the deployment interest settings
        interestSettings: business.overrideInterestSettings
          ? businessInterestSettings
          : deploymentInterestSettings,
        vendorCommissionBands,
        relationships,
        xeroIntegrationBusiness,
        id: business.id,
      };
      return acc;
    }, {});
  },
);

export const selectBusinessesAggridData = createSelector(
  [selectBusinessesAggridDataById],
  businessesAggridDataById => Object.values(businessesAggridDataById),
);
